// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7e57c2', // violeta suave (inicio del botón)
    },
    secondary: {
      main: '#ab47bc', // violeta más brillante (fin del botón)
    },
    background: {
      default: '#fdfdfd',
      paper: '#ffffffcc', // fondo del card de bienvenida
    },
    text: {
      primary: '#ffffff',
      secondary: '#f0f0f0',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  shadows: [
    'none',
    '0 4px 20px rgba(0, 0, 0, 0.3)', // custom para botón
    ...Array(23).fill('none'), // para completar las 25 sombras necesarias por MUI
    // ...podés agregar más si quieres
  ],
components: {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: "#1c1c1c", // fondo del campo
        color: "#ffffff", // texto
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#454346", // borde inactivo
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#a855f7", // hover
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#a855f7", // focus
        },
        "& input:-webkit-autofill": {
          WebkitBoxShadow: "0 0 0 1000px #1c1c1c inset",
          WebkitTextFillColor: "#ffffff",
          caretColor: "#ffffff",
          borderRadius: "4px",
        },
      },
    },
  },
},
});

export default theme;
